package one.healthium.tasks.domain

data class DailyTaskInfoModel(
    val type: DailyTaskType,
    val name: String,
    val color: Long,
)
